import { apiRequest } from './apiClient';

export const FORM_TASLAK_TIP_IADE = 'iade-fatura';
/** @deprecated Tek taslak — yeni akışta türe özel anahtarlar kullanın */
export const FORM_TASLAK_TIP_SIPARIS = 'siparis';
export {
  FORM_TASLAK_TIP_SIPARIS_GARANTI,
  FORM_TASLAK_TIP_SIPARIS_DOGRUDAN,
  FORM_TASLAK_TIP_SIPARIS_KONSIYE,
} from '../constants/siparisTaslak';

export const fetchFormTaslak = async (tip) => {
  try {
    const response = await apiRequest(`/api/form-taslaklar/${tip}`, { method: 'GET' });
    return response;
  } catch (err) {
    if (err?.status === 404) return null;
    throw err;
  }
};

export const saveFormTaslak = async (tip, veri) => {
  const response = await apiRequest(`/api/form-taslaklar/${tip}`, {
    method: 'PUT',
    body: { veri },
  });
  return response;
};

export const deleteFormTaslak = async (tip) => {
  const response = await apiRequest(`/api/form-taslaklar/${tip}`, {
    method: 'DELETE',
  });
  return response;
};
